import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Box, Typography, DialogActions, Grid } from "@mui/material";
import EMPButton from "../../EMPButton/EMPButton";

const DecisionIntro = ({
  analyticsPageView,
  handleDecision,
  text,
  primaryActionText,
  secondaryActionText,
}) => {
  useEffect(() => {
    if (analyticsPageView) {
      analyticsPageView();
    }
  }, [analyticsPageView]);

  const handleCancelClick = () => {
    handleDecision("cancel");
  };

  const handleAcceptClick = () => {
    handleDecision("accept");
  };

  return (
    <div>
      <Box>
        <Typography variant="body1" sx={{ mb: 6 }}>
          {text}
        </Typography>
      </Box>

      <DialogActions sx={{ padding: "16px 0" }}>
        <Grid container justifyContent="flex-end" spacing={4}>
          <Grid item>
            <EMPButton variant="outlined" onClick={handleCancelClick}>
              {secondaryActionText}
            </EMPButton>
          </Grid>
          <Grid item>
            <EMPButton variant="contained" onClick={handleAcceptClick}>
              {primaryActionText}
            </EMPButton>
          </Grid>
        </Grid>
      </DialogActions>
    </div>
  );
};

DecisionIntro.propTypes = {
  analyticsPageView: PropTypes.func,
  handleDecision: PropTypes.func.isRequired,
  text: PropTypes.node,
  primaryActionText: PropTypes.string,
  secondaryActionText: PropTypes.string,
};

export default DecisionIntro;
